import { FullScreenSpinner } from 'components/Elements';
import storage from 'utils/storage';
import { initReactQueryAuth } from 'react-query-auth';
import Cookies from 'js-cookie';
import {
  getLoggedInUser,
  verifyEmailOTPLogin,
} from 'features/authentication';

export async function handleUserResponse(data) {
  const { user } = data;
  storage.setToken(user.token);
  return user;
}

async function loadUser() {
  console.log('refreshing user....')
  if (storage.getToken()) {
    const { user } = await getLoggedInUser();

    console.log(user)

    storage.setToken(user.token);

    return user;
  }
  return null;
}

async function loginFn(data) {
  console.log(data);
  let user;
  // const response = await verifySMSOTPLogin(data);
  const response = await verifyEmailOTPLogin(data);
  user = await handleUserResponse(response);
  console.log(user);
  return user;
}

async function logoutFn() {
  storage.clearToken();
  Cookies.remove('identity_verified');
  window.location.assign(window.location.origin);
}

const authConfig = {
  loadUser,
  loginFn,
  logoutFn,
  LoaderComponent() {
    return (
      <div>
        <FullScreenSpinner />
      </div>
    );
  },
};

export const { AuthProvider, useAuth } = initReactQueryAuth(authConfig);
